var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullscreenExit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.984 8.01599H18.984V9.98499H14.015V5.01599H15.984V8.01599V8.01599ZM14.016 18.984V14.015H18.985V15.984H15.985V18.984H14.016ZM8.016 8.01599V5.01599H9.985V9.98499H5.016V8.01599H8.016V8.01599ZM5.016 15.984V14.015H9.985V18.984H8.016V15.984H5.016V15.984Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullscreenExit);
export default __webpack_public_path__ + "static/media/fullscreen-exit.2e73fe604c342c12ea2499a8ab2eaef7.svg";
export { ForwardRef as ReactComponent };